import React from 'react';
import { PropTypes } from 'prop-types';

const CircleDangerIcon = ({ color = '#fff', size = '40', stroke = '2' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 40 40">
        <g fill="none" fillRule="evenodd">
            <g transform="translate(9 9)">
                <circle cx="11" cy="11" r="11" stroke={color} strokeLinecap="square" strokeWidth={stroke} />
                <line x1="11" x2="11" y1="6" y2="12" stroke={color} strokeLinecap="square" strokeWidth={stroke} />
                <circle cx="11" cy="16" r="1" fill={color} fillRule="nonzero" />
            </g>
        </g>
    </svg>
);

CircleDangerIcon.propTypes = {
    color: PropTypes.string,
    size: PropTypes.string,
    stroke: PropTypes.string,
};

export default CircleDangerIcon;
